export default __webpack_public_path__ + "static/media/uic-sompo.b4c4d0e3.jpg";